import { Cookies } from 'react-cookie';
import FingerprintJS, { GetResult } from '@fingerprintjs/fingerprintjs';

type VisitorId = GetResult['visitorId'];

export const initializeFingerPrint = async () => {
  try {
    const fp = await FingerprintJS.load();
    const fp_result = await fp.get();
    const cookies = new Cookies();
    const expires = new Date();
    expires.setDate(expires.getDate() + 21);
    cookies.set('ZIGZAG_FINGERPRINT', fp_result.visitorId, {
      domain: '.zigzag.kr',
      path: '/',
      expires,
    });
  } catch (error) {
    console.error('Fingerprint 생성 실패: ', error);
  }
};

export const getFingerPrint = () => {
  const cookies = new Cookies();
  const fp_cookie: VisitorId = cookies.get('ZIGZAG_FINGERPRINT');
  if (fp_cookie) {
    return fp_cookie;
  }
  return null;
};
